import React, { Fragment } from 'react';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import Button from '../../../shared/form/_Button';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import TradeRequestModal from '../../../shared/modal/TradeRequestModal';
import moment from 'moment';
import { connect } from 'react-redux';
import appointmentAPI from '../../../../sources/api/appointmentAPI';

const OthersOfferDesktop = ({ othersOffers, showModal, modals, openFrequencyModal }) => {
  const _handleShowTradeRequestModal = (offer) => () => {
    appointmentAPI.verifyLimit({ id: offer.getIn(['appointment', 'id']) })
      .then(() => showModal(`tradeRequestModal${offer.get('id')}`))
      .catch(() => openFrequencyModal());
  };

  const isModalActive = (id) => modals && modals.getIn([id, 'active']);

  const formatScheduledOn = (offer) =>
    moment(offer.getIn(['appointment', 'scheduledOn']), 'YYYY-MM-DD').startOf('day').add(offer.getIn(['appointment', 'from']), 'seconds');

  return (
    othersOffers.valueSeq().map((offer) => (
      <Fragment key={ offer.get('id') }>
        <div className='trade-post__row' >
          <div className='trade-post__cell trade-post__one-fourth'>
            {offer.getIn(['appointment', 'office', 'name'])}
          </div>
          <div className='trade-post__cell trade-post__one-fourth'>
            {offer.getIn(['offerer', 'name'])}
          </div>
          <div className='trade-post__cell trade-post__one-fourth'>
            {convertDateToDayMonthYear(offer.getIn(['appointment', 'scheduledOn']))}{' '}
            {convertTime(offer.getIn(['appointment', 'from']))}
          </div>
          <div className='trade-post__cell trade-post__one-fourth'>
            <div className={ 'trade-post__buttons' }>
              <Button className='premium__rep-trade-button' onClick={ _handleShowTradeRequestModal(offer) }>Trade request</Button>
            </div>
          </div>
        </div>
        {isModalActive(`tradeRequestModal${offer.get('id')}`) && <TradeRequestModal id={ `tradeRequestModal${offer.get('id')}` }
          rep={ offer.getIn(['offerer']) }
          requestedAppointmentId={ offer.getIn(['appointment', 'id']) }
          requestedAppointmentScheduledOn={ formatScheduledOn(offer) } />
        }      </Fragment>
    ))
  );
};

OthersOfferDesktop.propTypes = {
  modals: PropTypes.instanceOf(Immutable.Map),
  openFrequencyModal: PropTypes.func.isRequired,
  othersOffers: PropTypes.instanceOf(Immutable.Map).isRequired,
  showModal: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({ modals: state.getIn(['tooltip', 'data']) });

export default connect(mapStateToProps)(OthersOfferDesktop);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/offers/OthersOffersDesktop.jsx